import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export const FacebookPixel = () => {
  useEffect(() => {
    // Initialize Facebook Pixel
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      // Create script element
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Add script to head
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
      // Create noscript element with pixel image
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1596463344592597&ev=PageView&noscript=1';
      noscript.appendChild(img);
      // Add noscript to head
      head.appendChild(noscript);
      // Initialize pixel
      window.fbq('init', '1596463344592597');
      window.fbq('track', 'PageView');
    }
  }, []);
  return null;
};